export default __webpack_public_path__ + "static/media/Next.98c0c675.svg";